import api from "./api"

export const columnService = {
    getColumn: async (numBoard) => {
        try {
            const response = await api.get(`api/Column/by-board/${numBoard}`);
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao buscar as colunas [${status}]: ${JSON.stringify(message)}`);
        }
    },
    getColumns: async () => {
        try {
            const response = await api.get('api/Column');
            return response.data;
        } catch (error) {
            throw new Error('Erro ao buscar as colunas');
        }
    },
    createColumn: async (name, numBoard) => {
        try {
            const response = await api.post('api/Column', {
                Name: name,
                numBoard: numBoard
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao criar a coluna [${status}]: ${JSON.stringify(message)}`);
        }
    },
    updateColumn: async (numColumn, numBoard, name, ativo, order) => {
        try {
            const response = await api.put(`api/Column/${numColumn}`, {
                numColumn,
                numBoard,
                name,
                ativo,
                order
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao atualizar a coluna [${status}]: ${JSON.stringify(message)}`);
        }
    },
    deleteColumn: async (numColumn, numBoard, name, order) => {
        try {
            const response = await api.put(`api/Column/${numColumn}`, {
                numColumn,
                numBoard,
                name,
                ativo: false,
                order
            });
            return response.data;
        } catch (error) {
            const status = error.response?.status;
            const message = error.response?.data?.message || error.response?.data || error.message;
            throw new Error(`Erro ao excluir a coluna [${status}]: ${JSON.stringify(message)}`);
        }
    },
};